import { useState } from 'react';
import { useSelector } from 'react-redux';
import ResourcesList from './ResourcesList';
import TablePageContainer from '../../Shared/Table/widgets/TablePageContainer';
import TableTitle from '../../Shared/Table/widgets/TableTitle';

const Resources = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const [filterStyle, setFilterStyle] = useState(false);
  const [aggregations, setAggregations] = useState([]);

  return <TablePageContainer>
    <ResourcesList
      setFilterStyle={setFilterStyle}
      setAggregations={setAggregations}
      tableTitle={<TableTitle
        titleText={titles.resources}
        count={aggregations?.PatientsCount}
        countFiltered={filterStyle}
      />}
    />
  </TablePageContainer>;
};

export default Resources;
